export const GENDER_RESTRICTIONS = {
  FEMALE_ROOM: 'offer-males',
  FEMALE_PROPERTY: 'property-males',
  MALE_ROOM: 'offer-females',
  MALE_PROPERTY: 'property-females'
};
